/** Tareas a CSV para Excel u otras herramientas. */
import type { TaskItem } from './api'

/** CSV (separado por punto y coma, como lo abre Excel en español) con BOM para las tildes. */
export function tasksCsv(tasks: TaskItem[], hechas: Set<string>): string {
  const cel = (v: string | null) => `"${(v ?? '').replace(/"/g, '""')}"`
  const filas = tasks.map((t) =>
    [
      t.descripcion,
      t.responsableMencionado ?? t.responsableNombre ?? t.responsableEtiqueta,
      t.fecha,
      t.titulo,
      t.fechaReunion.slice(0, 10),
      hechas.has(t.id) ? 'sí' : 'no'
    ]
      .map(cel)
      .join(';')
  )
  return (
    '\ufeff' + ['Tarea;Responsable;Fecha;Reunión;Fecha de la reunión;Hecha', ...filas].join('\r\n')
  )
}
